import { render } from "./client-modal.vue?vue&type=template&id=0a978079"
import script from "./client-modal.vue?vue&type=script&lang=js"
export * from "./client-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__